import React, { useState } from 'react';
import './SearchBar.scss';
import messages from '../messages';

export default function ({ lang, q = '' }) {
  const [state, setState] = useState('');
  const trans = messages[lang];

  return (
    <form id="stadat-search-bar" acceptCharset="utf-8" className={state}>
      <input
        type="text"
        name="q"
        defaultValue={q}
        placeholder={trans.searchInStadat}
        aria-label={trans.searchInStadat}
        onFocus={() => setState('focused')}
        onBlur={() => setState('')}
      />
      <input type="hidden" name="lang" value={lang} />
      <button type="submit" title={trans.searchLabel} aria-label={trans.searchLabel}>
        <svg className="icon icon-search" aria-hidden="true">
          <use href="/images/icons.svg#search"></use>
        </svg>
      </button>
    </form>
  );
};
